import React from "react";
import harnessImage from "../assets/images/harness.png";
import { useNavigate } from "react-router-dom";


export default function ProductCard({
  id,
  title,
  price,
  variants,
  image,
  unitsAvailable,
  delivery,
  fastest
}) {
const navigate = useNavigate();
const displayPrice =
  variants?.length
    ? Math.min(...variants.map(v => v.price))
    : price || 0;

const [main, cents] = Number(displayPrice)
  .toFixed(2)
  .split(".");


const getDeliveryRange = () => {
  const today = new Date();

  const start = new Date(today);
  start.setDate(today.getDate() + 2);

  const end = new Date(today);
  end.setDate(today.getDate() + 5);

  const options = { weekday: "short", month: "short", day: "numeric" };

  return `${start.toLocaleDateString("en-US", options)} - ${end.toLocaleDateString("en-US", options)}`;
};
  
  const styles = {

   card: {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  padding: "18px",
  borderRadius: "22px",
  position: "relative",

  background: "linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",
  border: "2px solid #ffffff",

  boxShadow:
    "0 0 30px rgba(120,170,255,0.18), \
     0 20px 50px rgba(0,0,0,0.10), \
     0 6px 18px rgba(0,0,0,0.06), \
     inset 0 1px 0 rgba(255,255,255,1)",

  transition: "all 0.22s ease", // 👈 THIS is what you were missing
  cursor: "pointer",

  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui"
},

    stockBadge: {
      position: "absolute",
      top: "12px",
      left: "12px",

      padding: "4px 10px",

      fontSize: "12px",
      fontWeight: 600,

      borderRadius: "14px",

      background: "rgba(166, 186, 234, 0.12)",
      border: "1px solid rgba(62,111,227,0.28)"
    },

    imageWrap: {
      width: "100%",
      height: "180px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },

    image: {
      width: "90%",
      objectFit: "contain"
    },

    divider: {
      height: "1px",
      width: "100%",
      margin: "10px 0",
      background:
        "linear-gradient(to right, transparent, #e3e3e8, transparent)"
    },

    content: {
      textAlign: "center"
    },

    itemTitle: {
      fontSize: "16px",
      color: "#1d1d1f",
      marginBottom: "6px",
      lineHeight: "22px"
    },




delivery: {
  fontSize: "13px",
  color: "#444",
  marginBottom: "2px"
},

fastest: {
  fontSize: "13px",
  color: "#444",
  marginBottom: "10px"
},

button: {
  marginTop: "10px",
  padding: "10px 18px",
  height: "42px",
  borderRadius: "30px",
  border: "none",
  background: "linear-gradient(180deg,#5a8efc,#1f57c8)",
  color: "white",
  fontWeight: 600,
  fontSize: "14px",
  cursor: "pointer",
  width: "100%",
  transition: "all 0.18s ease",
  boxShadow:
    "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)"
},





    priceRow: {
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      marginBottom: "14px"
    },

    priceDollar: { fontSize: "16px" },
    priceMain: { fontSize: "26px", fontWeight: 500 },
    priceCents: { fontSize: "16px" }

  };

return (
  <div
    style={styles.card}
    onClick={() => navigate(`/product/${id}`)}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-8px)";
      e.currentTarget.style.boxShadow =
        "0 40px 90px rgba(0,0,0,0.14), 0 22px 55px rgba(62,111,227,0.20)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow =
        "0 0 30px rgba(120,170,255,0.18), \
         0 20px 50px rgba(0,0,0,0.10), \
         0 6px 18px rgba(0,0,0,0.06), \
         inset 0 1px 0 rgba(255,255,255,1)";
    }}
  >
    <div style={styles.stockBadge}>
      {(unitsAvailable ?? 1) > 0 ? "In Stock" : "Out of Stock"}
    </div>

    <div style={styles.imageWrap}>
      <img src={image || harnessImage} style={styles.image} />
    </div>

    <div style={styles.divider}></div>

    <div style={styles.content}>
      <div style={styles.itemTitle}>{title}</div>

      <div style={styles.priceRow}>
        <span style={styles.priceDollar}>$</span>
        <span style={styles.priceMain}>{main}</span>
        <span style={styles.priceCents}>{cents}</span>
      </div>

      <div style={styles.delivery}>
  FREE delivery <b>{getDeliveryRange()}</b>
</div>

      <div style={styles.fastest}>
        ⚡ Or fastest delivery <b>{fastest}</b>
      </div>

     <button
  style={styles.button}
  onClick={(e) => {
    e.stopPropagation();
    navigate(`/product/${id}`);
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow =
      "0 18px 38px rgba(62,111,227,0.45), 0 8px 18px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.35)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)";
  }}
>
  Buy Now
</button>
    </div>
  </div>
);
}